<script setup lang="ts">
    import {ref} from 'vue';
    import {useSearchSubmit} from './useSearchSubmit';

    const props = defineProps<{disabled: boolean}>();

    const emit = defineEmits<{(event: 'search', vin: string): void}>();

    const vin = ref('');

    const {field, submit} = useSearchSubmit(
        () => props.disabled,
        () => vin.value,
        (raw) => raw.trim(),
        (value) => emit('search', value)
    );
</script>

<template>
    <form
        class="c-vin-search-row"
        @submit.prevent="submit">
        <div class="c-vin-input">
            <div class="c-vin-input__field">
                <input
                    ref="field"
                    v-model="vin"
                    class="c-vin-input__control"
                    type="text"
                    name="vin"
                    maxlength="17"
                    autocomplete="off"
                    spellcheck="false"
                    aria-label="VIN-nummer"
                    placeholder="VIN-nummer"
                    :disabled="disabled" />
            </div>
            <button
                type="submit"
                class="c-vin-input__search"
                aria-label="Zoek"
                :disabled="disabled">
                <i class="fa fa-search"></i>
            </button>
        </div>
    </form>
</template>
